import { render, staticRenderFns } from "./catalog.cattle.io.app.vue?vue&type=template&id=502e4a6b&scoped=true&"
import script from "./catalog.cattle.io.app.vue?vue&type=script&lang=js&"
export * from "./catalog.cattle.io.app.vue?vue&type=script&lang=js&"
import style0 from "./catalog.cattle.io.app.vue?vue&type=style&index=0&id=502e4a6b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502e4a6b",
  null
  
)

export default component.exports